import { render, staticRenderFns } from "./ScoreboardDropdown.vue?vue&type=template&id=2b70151c&scoped=true"
import script from "./ScoreboardDropdown.vue?vue&type=script&lang=js"
export * from "./ScoreboardDropdown.vue?vue&type=script&lang=js"
import style0 from "./ScoreboardDropdown.vue?vue&type=style&index=0&id=2b70151c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b70151c",
  null
  
)

export default component.exports